import {createEntityAdapter} from '@reduxjs/toolkit';
import compareAsc from 'date-fns/compareAsc';
import parseISO from 'date-fns/parseISO';
import {Meeting, MeetingSuggestion, TimeZone} from '../entities';
import {byProp} from '@lib/utils';

export const meetingsAdapter = createEntityAdapter<Meeting>({
  selectId: (meeting) => meeting.id,
  sortComparer: (m1, m2) => compareAsc(parseISO(m1.startDateTime), parseISO(m2.startDateTime)),
});

export const suggestionsAdapter = createEntityAdapter<MeetingSuggestion>({
  selectId: (suggestion) => suggestion.id,
  sortComparer: byProp('timeSlotStart'),
});

export const timeZonesAdapter = createEntityAdapter<TimeZone>();
